import { useState } from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

export type EnumOption = {
  name: string
  id: string
}

type Props = {
  enumValues: Array<EnumOption>
  cellValue: string
  onChange: (newValue: EnumOption) => void
  isValid: boolean
  rowWithError?: boolean
}

const EnumSelector = ({ enumValues, cellValue, onChange, isValid, rowWithError }: Props) => {
  const [newEnumValues, setNewEnumValues] = useState<Array<EnumOption>>(
    [...enumValues, !isValid ? { name: cellValue, id: cellValue } : undefined].filter(Boolean)
  )

  const handleOnChange = (newValue: EnumOption | undefined) => {
    if (!newValue) return
    onChange(newValue)
    setNewEnumValues(enumValues)
  }

  const tagType = rowWithError ? 'radical' : isValid ? 'neutral' : 'tangerine'

  return (
    <Box position="relative" paddingLeft="s16">
      {/* eslint-disable-next-line factorial/no-raw-html */}
      <select
        onChange={(e) => handleOnChange(enumValues.find((x) => x.id.toString() === e.target.value))}
        value={cellValue}
        style={{
          outline: 'none',
          opacity: 0,
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        title={cellValue}
      >
        {newEnumValues.map((option, index) => (
          // eslint-disable-next-line factorial/no-raw-html
          <option key={index} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
      <Tag type={tagType} size="normal" showActionIcon rightItem="dropdown">
        {newEnumValues.find((x) => x.id === cellValue)?.name || cellValue}
      </Tag>
    </Box>
  )
}

export default observer(EnumSelector)
